import { render, staticRenderFns } from "./ModalSuccessForm.vue?vue&type=template&id=2612899b&"
import script from "./ModalSuccessForm.vue?vue&type=script&lang=js&"
export * from "./ModalSuccessForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports